import React, { useState } from 'react';
import { FiX, FiCheck } from 'react-icons/fi';
import './ContentPersonalizationModal.css';
import menstrualImg from "../../images/menstrual.png";
import contraceptionImg from "../../images/contraception.png";
import fertilityImg from "../../images/fertility.png";
import stiawarenessImg from "../../images/sti.png";
import mentalhealthImg from "../../images/mentalhealth.png";
import malereproductiveImg from "../../images/malereproductive.png";
import pregnancyImg from "../../images/pregnancy.png";
import generalwellnessImg from "../../images/general.png";
import communityImg from "../../images/community.png";
import { auth } from '../../firebase';
import { userService } from '../../services/firestoreService';

const ContentPersonalizationModal = ({ onClose }) => {
  const [selectedTopics, setSelectedTopics] = useState([]);

  const topics = [
    { id: 1, name: 'Menstrual Wellness and Hygiene', icon: menstrualImg },
    { id: 2, name: 'Contraception', icon: contraceptionImg },
    { id: 3, name: 'Fertility Basics', icon: fertilityImg },
    { id: 4, name: 'STI Awareness', icon: stiawarenessImg  },
    { id: 5, name: 'Mental Health in Reproductive Care', icon: mentalhealthImg },
    { id: 6, name: 'Male Reproductive Health', icon: malereproductiveImg },
    { id: 7, name: 'Pregnancy Prevention', icon: pregnancyImg },
    { id: 8, name: 'General Reproductive Wellness', icon: generalwellnessImg },
    { id: 9, name: 'Community Outreach Programs', icon: communityImg }
  ];

  const handleTopicToggle = (topicId) => {
    setSelectedTopics(prev => 
      prev.includes(topicId) 
        ? prev.filter(id => id !== topicId)
        : [...prev, topicId]
    );
  };

  const handleContinue = async () => {
    // Store selected topics in users collection in Firestore
    try {
      const user = auth.currentUser;
      if (!user) {
        console.error('ContentPersonalizationModal: No authenticated user found');
        return;
      }

      const preferences = {
        selectedTopics: selectedTopics,
        topics: topics.filter(topic => selectedTopics.includes(topic.id)).map(topic => topic.name),
        timestamp: new Date().toISOString()
      };

      // Update user document with content preferences
      await userService.updateUser(user.uid, {
        contentPreferences: preferences
      });

      // Close modal
      onClose();
      
      // Clear the fromSignup flag from location state to prevent modal from showing again
      try {
        const st = window.location.state || {};
        if (st.fromSignup) {
          const cleaned = { ...st };
          delete cleaned.fromSignup;
          window.history.replaceState(
            { ...window.history.state, usr: cleaned, key: window.history.state?.key, idx: window.history.state?.idx },
            document.title
          );
        }
      } catch (_) {
        // best effort — ignore if replaceState fails for any reason
      }
    } catch (error) {
      console.error('ContentPersonalizationModal: Error storing preferences:', error);
      alert('Failed to save preferences. Please try again.');
    }
  };

  return (
    <div className="personalization-modal-overlay">
      <div className="personalization-modal">
        <div className="modal-header">
          <div className="modal-header-content">
            <h2>Personalize Your Content</h2>
            <p>Choose topics that matter to you.</p>
          </div>
          <button className="modal-close-btn" onClick={() => {
            onClose();
            // Clear the fromSignup flag from location state to prevent modal from showing again
            try {
              const st = window.location.state || {};
              if (st.fromSignup) {
                const cleaned = { ...st };
                delete cleaned.fromSignup;
                window.history.replaceState(
                  { ...window.history.state, usr: cleaned, key: window.history.state?.key, idx: window.history.state?.idx },
                  document.title
                );
              }
            } catch (_) {
              // best effort — ignore if replaceState fails for any reason
            }
          }}>
            <FiX />
          </button>
        </div>
        
        <div className="topics-grid">
          {topics.map(topic => (
            <button
              key={topic.id}
              className={`topic-button ${selectedTopics.includes(topic.id) ? 'selected' : ''}`}
              onClick={() => handleTopicToggle(topic.id)}
            >
              {selectedTopics.includes(topic.id) && (
                <div className="topic-checkmark">
                  <FiCheck />
                </div>
              )}
              <div className="topic-icon">
                <img src={topic.icon} alt={topic.name} onError={(e) => {
                  e.target.src = '/assets/icons/default.png';
                }} />
              </div>
              <span className="topic-name">{topic.name}</span>
            </button>
          ))}
        </div>
        
        <div className="modal-footer">
          <button 
            className="later-button" 
            onClick={() => {
              onClose();
              // Clear the fromSignup flag from location state to prevent modal from showing again
              try {
                const st = window.location.state || {};
                if (st.fromSignup) {
                  const cleaned = { ...st };
                  delete cleaned.fromSignup;
                  window.history.replaceState(
                    { ...window.history.state, usr: cleaned, key: window.history.state?.key, idx: window.history.state?.idx },
                    document.title
                  );
                }
              } catch (_) {
                // best effort — ignore if replaceState fails for any reason
              }
            }}
          >
            Later
          </button>
          <button 
            className="continue-button" 
            onClick={handleContinue}
            disabled={selectedTopics.length === 0}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentPersonalizationModal;
